// Click to call event tracking - MEM

// jquery( document ).ready(function() {
// jquery('#click-to-call-desktop').click(function(){
// 	ga('event', 'Click to Call');
//          console.log('Click to call ga triggered');
// });
// });
if (document.getElementById('click-to-call-desktop')){
  document.getElementById('click-to-call-desktop').onclick=function(){
    ga('send', 'event', 'Click To Call', 'click', 'Desktop Header');
    console.log('Click to call desktop header ga triggered');
  }
}
if (document.getElementById('click-to-call-contact-page')){
  document.getElementById('click-to-call-contact-page').onclick=function(){
    ga('send', 'event', 'Click To Call', 'click', 'Contact Us Page');
    console.log('Click to call contact us page');
  }
}
if (document.getElementById('click-to-call-footer')){
  document.getElementById('click-to-call-footer').onclick=function(){
    ga('send', 'event', 'Click To Call', 'click', 'Footer');
    console.log('Click to call footer');
  }
}